var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 157.393,
    height: 128.844,
    viewBox: "0 0 157.393 128.844",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.e{fill:#7556e8;}.a,.h,.n{opacity:0.1;}.b{opacity:0.7;}.c{fill:#f6f7f9;}.d{opacity:0.2;}.f{fill:url(#a);}.g{opacity:0.5;}.i{fill:url(#c);}.j{fill:url(#d);}.k{fill:#efb7b9;}.l{fill:#444053;}.m{fill:#b07473;}.o{fill:#e1e7ef;}.p{fill:#67647e;}.q{fill:#585268;}.r{opacity:0.03;}.s{fill:url(#e);}.t{fill:#a27772;}.u{fill:#cc818c;}.v{fill:#f6f8fb;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.5,
    y1: 1.228,
    x2: 0.5,
    y2: 0.201,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.017)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 27.066,
    cy: 4.612,
    rx: 27.066,
    ry: 4.612,
    transform: "translate(0 119.637)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 27.066,
    cy: 4.612,
    rx: 27.066,
    ry: 4.612,
    transform: "translate(103.261 118.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.016,31.165c-7.074.378-14.222,2.445-19.741,6.888-4.843,3.9-8.335,10.031-7.483,16.192,1.006,7.272,7.494,12.563,9.9,19.5,1.549,4.46,1.307,9.381.294,13.994a19.534,19.534,0,0,1-3.582,8.3c-3.471,4.238-9.735,6.284-11.44,11.489-1.855,5.661,2.819,11.212,7.209,15.238,3.5,3.213,7.176,6.41,11.592,8.171a32.045,32.045,0,0,0,10.208,1.936,68.081,68.081,0,0,0,28.142-4.5c4.292-1.665,8.444-3.777,12.936-4.781,9.573-2.141,19.423.946,29.125,2.391a87.109,87.109,0,0,0,25.093.074c5.238-.747,10.649-2.1,14.594-5.621a18.549,18.549,0,0,0,5.776-14.485,25.87,25.87,0,0,0-5.819-14.748c-4.306-5.442-10.245-9.315-15.412-13.953a66.64,66.64,0,0,1-13.259-16.39c-2.03-3.537-3.757-7.291-6.387-10.405-4.1-4.853-10.05-7.74-15.994-9.97-13.711-5.136-27.933-6.182-42.229-8.452A64.592,64.592,0,0,0,184.016,31.165Z",
    transform: "translate(-141.816 -31.08)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(39.759 11.117)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 29.367,
    height: 16.41,
    transform: "translate(0 45.352)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(2.471 49.58)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.057,
    cy: 3.057,
    r: 3.057
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(12.313 49.014)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 13.321,
    height: 0.838
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(12.313 51.15)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.786,
    height: 0.838,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(12.313 53.286)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 10.976,
    height: 0.838,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(12.313 55.422)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 13.321,
    height: 0.838,
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(21.95 58.506)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.686,
    height: 1.619
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 29.367,
    height: 16.41,
    transform: "translate(24.724)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(27.197 4.228)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.057,
    cy: 3.057,
    r: 3.057
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(37.039 3.662)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 13.321,
    height: 0.838
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(37.039 5.798)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.786,
    height: 0.838
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(37.039 7.934)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 10.976,
    height: 0.838
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(37.039 10.071)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 13.321,
    height: 0.838
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(46.673 13.153)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.686,
    height: 1.619
  })), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 29.367,
    height: 16.41,
    transform: "translate(34.498 27.552)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(36.97 31.781)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 3.057,
    cy: 3.057,
    r: 3.057
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(46.813 31.215)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 13.321,
    height: 0.838
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(46.813 33.351)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.786,
    height: 0.838
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(46.813 35.487)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 10.976,
    height: 0.838
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(46.813 37.623)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 13.321,
    height: 0.838
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(56.448 40.707)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.686,
    height: 1.619,
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 49.382,
    height: 27.903,
    transform: "translate(29.508 20.884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 48.688,
    height: 27.209,
    transform: "translate(29.857 21.23)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(33.954 28.241)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 5.069,
    cy: 5.069,
    r: 5.069
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(50.275 27.302)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.086,
    height: 1.389
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(50.275 30.845)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 11.251,
    height: 1.389
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(50.275 34.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 18.197,
    height: 1.389
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(50.275 37.928)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 22.086,
    height: 1.389
  })), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 6.111,
    height: 2.685,
    transform: "translate(66.249 43.04)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 46.969,
    height: 26.246,
    transform: "translate(64.146 58.578)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 46.32,
    height: 25.885,
    transform: "translate(64.471 58.758)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(68.369 65.428)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 4.823,
    cy: 4.823,
    r: 4.823
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(83.895 64.534)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 21.012,
    height: 1.321
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(83.895 67.905)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 10.703,
    height: 1.321
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(83.895 71.275)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 17.311,
    height: 1.321
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(83.895 74.644)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 21.012,
    height: 1.321
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(99.092 79.507)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 5.815,
    height: 2.554
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(12.743 44.289)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M171.13,318.987l.114.025A.154.154,0,0,0,171.13,318.987Z",
    transform: "translate(-171.13 -318.985)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M155.572,278.67a55.391,55.391,0,0,0-2.413-7.606h0c-.037-.154-.077-.317-.123-.474-1.472-5.058-3.508-5.505-3.508-5.505l-7.294-1.555a.544.544,0,0,1,.154.145l-.115.018a2.856,2.856,0,0,1-.64-1.384c-.014-.075-.026-.154-.035-.234a5.129,5.129,0,0,0-.418-7.714c-.075-.06-.154-.117-.234-.174a1.164,1.164,0,0,0,.1-1.384,4.811,4.811,0,0,0-3.11-2.318,5.268,5.268,0,0,0-3.017-.065,11.041,11.041,0,0,0-1.579.732,9.024,9.024,0,0,0-2.768,1.662.813.813,0,0,0-.277.667,1.8,1.8,0,0,0,.275.486,1.479,1.479,0,0,1,.014,1.215c-.14.4-.352.769-.452,1.169a1.22,1.22,0,0,0,.245,1.172,5.293,5.293,0,0,0,.461.323,2.347,2.347,0,0,1,.435.487l.864,1.167a11.925,11.925,0,0,1,1.076,1.644,7.843,7.843,0,0,0,.669,1.255,1.971,1.971,0,0,0,.288.308c-.028-.011-.057-.02-.085-.032a1.309,1.309,0,0,0,.966.371h.043a.263.263,0,0,0,.177-.072v.154c.015.561.014,1.158-.026,1.718l-.068-.034a.586.586,0,0,0-.629.066l-6.719,5.382a8.856,8.856,0,0,0-1.256,5.444l-1.176,5.17s-1.472,4.387-.34,7.52,1.788,4.921,1.788,4.921.452,3.559,1.132,3.845.973.449.973.449l.135.85h0s.045.082.125.223c.5.86,2.327,3.9,3.392,3.572a13.814,13.814,0,0,1,.174,2.493l1.052,7.074a10.432,10.432,0,0,1,.691,2.931,5.571,5.571,0,0,0,.86,2.441,4.666,4.666,0,0,0-.452,3.289c.431,1.881.973,10.563.973,10.563l.792,2.1-.023,2.461a2.359,2.359,0,0,1-.486,1.092c-.511.554-.477,1.193-1.692,1.948s-2,1.04-2,2.047a2.657,2.657,0,0,1-.037.415c-.114.737-.334,1.133,1.922,1.349a5.94,5.94,0,0,0,4.414-1.478s.389-.706,2.224-.99c0,0,.626-.034.661-.589.012-.191.009-.557-.008-.96a5.923,5.923,0,0,0-.2-1.709,3.736,3.736,0,0,1-.411-1.107h.511a22.139,22.139,0,0,0,0-5.865,9.408,9.408,0,0,1-.045-3.938l-.091-6.087a1.663,1.663,0,0,1-.138-1.835c.5-1.184,0-7.049,0-7.049s.183-2.1.7-2.6.026-3.083,0-3.219l.923,3.106s.408,6.178,1.269,7.3l.249,2.8s1.765,2.574,1.426,3.963.363,6.4.363,6.4v5.126s-.794,2.059.317,2.8l.478-.018c-.163.154-.28.368-.461.557a4.243,4.243,0,0,0-.4,1.762c-.057.6-.075,1.124-.075,1.124a1.859,1.859,0,0,0,1.358.806c.883.051,3.8,2.284,3.8,2.284a35.27,35.27,0,0,0,3.634-.154l.045-.011a.986.986,0,0,0,.563-.461,1.175,1.175,0,0,0,.137-.846,2.121,2.121,0,0,0-1.219-1.336c-1.936-1.023-2.224-1.979-2.224-1.979l-1.269-1.9h.181a8.123,8.123,0,0,1,1.267-4.275l-.089-9.959s.564-3.425-.408-5.282c0,0-.08-1.97.571-2.574s-.866-6.714-.866-6.714-.308-3.279-.683-6.271h0c1.527,1.449,3.113-3.769,3.383-4.7h.04s-.008-.025-.018-.068a.065.065,0,0,1,.018-.066h0c0-.008-.338-1.207-.091-.963s.861-.67.861-.67-.091-4.992.973-7.508S155.572,278.67,155.572,278.67Zm-4.55,3.176.008-.014c.154,3.048-.031,9.552-.031,9.552s-.209.833-.434,1.815l-.161-6.179h0l-.154-5.819Zm-19.489-2.1s.769,9.624,0,11.011a7.18,7.18,0,0,0-.555,1.9,7.018,7.018,0,0,1-.6-3.065c.249-1.077-.5-3.9-.5-3.961a6.66,6.66,0,0,1,.475-2.72c.543-1.153.181-1.645.181-1.645S130.99,279.387,131.533,279.745Z",
    transform: "translate(-119.036 -216.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M159.336,556.808c-.669,2.947-3.336-1.51-3.943-2.579l-.123-.222.289-1.355,1.529-.623a4.226,4.226,0,0,1,.683.446A4.108,4.108,0,0,1,159.336,556.808Z",
    transform: "translate(-144.966 -471.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M292.033,547.585l-.017.066a.4.4,0,0,1-.022.072c-.261.923-1.816,6.1-3.317,4.661-1.642-1.578-.844-5.2-.844-5.2h.015l3.456-.354.684.7h0Z",
    transform: "translate(-256.979 -467.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M186.957,575.336l.088,9.885a8.149,8.149,0,0,0-1.244,4.244l-4.46.177c-1.089-.732-.308-2.776-.308-2.776v-5.089s-.7-4.973-.364-6.357-1.4-3.932-1.4-3.932l-.243-2.776c-.846-1.11-1.246-7.243-1.246-7.243l-.909-3.076c.023.134.5,2.719,0,3.194s-.689,2.577-.689,2.577.489,5.821,0,7a1.731,1.731,0,0,0,.132,1.845l.091,6.042a9.452,9.452,0,0,0,.043,3.911,22.235,22.235,0,0,1,0,5.821h-4.8l.022-2.461-.777-2.088s-.534-8.62-.955-10.485a4.681,4.681,0,0,1,.443-3.266,5.559,5.559,0,0,1-.843-2.422,10.418,10.418,0,0,0-.678-2.91l-1.033-7.02a13.617,13.617,0,0,0-.511-4c-.6-2-1.489-4.621-1.489-4.621l1,.089,5.063.451s12.3-.827,12.858-.14a2.3,2.3,0,0,1,.234.717c.552,2.484,1.283,10.259,1.283,10.259s1.489,6.065.849,6.665-.56,2.554-.56,2.554C187.512,571.938,186.957,575.336,186.957,575.336Z",
    transform: "translate(-153.903 -469.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M185.43,803.413c-.035.551-.651.584-.651.584-1.8.283-2.181.984-2.181.984a5.817,5.817,0,0,1-4.329,1.473c-2.213-.212-2-.615-1.885-1.338a2.615,2.615,0,0,0,.035-.412c0-1,.769-1.284,1.967-2.033s1.166-1.384,1.665-1.933a3.051,3.051,0,0,0,.551-1.615c.566-.984,2,.154,2,.154.066.349,2.2.307,2.2.307a4.744,4.744,0,0,0,.428,1.2,5.938,5.938,0,0,1,.2,1.692C185.439,802.861,185.441,803.226,185.43,803.413Z",
    transform: "translate(-162.779 -680.658)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M185.43,823.956c-.035.551-.651.584-.651.584-1.8.283-2.181.984-2.181.984A5.817,5.817,0,0,1,178.27,827c-2.213-.212-2-.615-1.885-1.338.989.246,2.88.588,3.985-.012,1.538-.834,2.634-1.416,2.634-1.416L185.422,823C185.439,823.4,185.441,823.769,185.43,823.956Z",
    transform: "translate(-162.779 -701.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M272.959,809.751a.966.966,0,0,1-.554.461.219.219,0,0,1-.043.011,33.994,33.994,0,0,1-3.566.154s-2.871-2.224-3.732-2.274a1.84,1.84,0,0,1-1.333-.8s.017-.517.072-1.116a4.261,4.261,0,0,1,.394-1.75c.384-.4.461-.949,1.333-.6,0,0,1.23-2.17,2.682-.494l1.5,2.277s.283.949,2.184,1.965a2.085,2.085,0,0,1,1.195,1.326A1.173,1.173,0,0,1,272.959,809.751Z",
    transform: "translate(-236.747 -684.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M272.959,828.895c-.169.143-.358.3-.554.461a.228.228,0,0,1-.043.011,34.008,34.008,0,0,1-3.566.154s-2.871-2.224-3.732-2.274a1.84,1.84,0,0,1-1.333-.8s.017-.517.072-1.116a6.238,6.238,0,0,1,2.577,1.23,10.75,10.75,0,0,0,2.218,1.832s3.111-.3,4.494-.34A1.173,1.173,0,0,1,272.959,828.895Z",
    transform: "translate(-236.747 -703.173)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M199.329,315.687l-4.1,4.332s-4.966-.366-4.1-1.833a8.231,8.231,0,0,0,.472-3.669c-.037-1.312-.172-2.428-.172-2.428s6.965-3.466,6.431-.234a5.362,5.362,0,0,0-.02,1.845A2.427,2.427,0,0,0,199.329,315.687Z",
    transform: "translate(-175.226 -267.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M200.061,311.855a5.362,5.362,0,0,0-.02,1.845,5.112,5.112,0,0,1-3.645,1.521A6.148,6.148,0,0,1,193.675,314c-.037-1.312-.045-1.91-.045-1.91S200.595,308.622,200.061,311.855Z",
    transform: "translate(-177.427 -267.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M188.5,277.983a5.133,5.133,0,1,1-1.932-4.011A5.133,5.133,0,0,1,188.5,277.983Z",
    transform: "translate(-164.402 -235.657)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M189.225,551.037c-1.278,3.042-9.5,3.1-9.5,3.1v-3.316l-.5-.032a11.351,11.351,0,0,1-.308,3.265c-6.5.923-8.08-2.782-8.08-2.782l.225-1.267,5.063.451s12.3-.827,12.858-.14a2.3,2.3,0,0,1,.24.717Z",
    transform: "translate(-158.142 -470.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M179.726,376.35v-3.317l-.5-.031a11.351,11.351,0,0,1-.308,3.265c-4.889.689-7-1.23-7.74-2.23a3.023,3.023,0,0,1-.34-.554l1.982-11.163.461-16.429L174,343.01l.166-1.384v-.015l.017.008.5.217,3.026,1.307,3.456-2.594.051-.038.171-.129.285.229.706.566,2.267,14.631s3.931,11.266,4.66,15.814c.029.181.054.351.072.509C189.857,376.273,179.726,376.35,179.726,376.35Z",
    transform: "translate(-158.142 -292.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 0.292,
    cy: 0.292,
    r: 0.292,
    transform: "translate(19.658 50.366)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 0.292,
    cy: 0.292,
    r: 0.292,
    transform: "translate(19.794 53.031)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 0.292,
    cy: 0.292,
    r: 0.292,
    transform: "translate(20.084 57.348)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 0.292,
    cy: 0.292,
    r: 0.292,
    transform: "translate(20.569 61.995)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 0.292,
    cy: 0.292,
    r: 0.292,
    transform: "translate(20.859 66.361)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 0.292,
    cy: 0.292,
    r: 0.292,
    transform: "translate(21.151 71.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 0.292,
    cy: 0.292,
    r: 0.292,
    transform: "translate(21.035 75.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M174.464,370.477s-.326,4.275-.923,5.518a20.419,20.419,0,0,0-.867,4.732l-1.384-.154a3.022,3.022,0,0,1-.34-.554l1.982-11.163.461-16.429.715-2.882.166-1.384a.041.041,0,0,1,.018-.008.561.561,0,0,1,.5.008l.068.034c-.02.057-.04.115-.058.175a26.8,26.8,0,0,0-.744,4.833s.778,5.732.866,8.4S174.464,370.477,174.464,370.477Z",
    transform: "translate(-158.235 -299.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M157.771,552.476a.937.937,0,0,1-.052.1,5,5,0,0,1-2.325,1.65l-.123-.222.289-1.355,1.529-.623A4.226,4.226,0,0,1,157.771,552.476Z",
    transform: "translate(-144.966 -471.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M130,413.06l-1.266.76-1.156,5.132s-1.444,4.355-.332,7.465S129,431.3,129,431.3s.444,3.537,1.11,3.822.957.444.957.444l.132.844a5.3,5.3,0,0,0,2.448-1.692c.64-1.077-.471-3.769-.471-3.769s-.955-2.288-.71-3.354-.489-3.866-.489-3.932a6.736,6.736,0,0,1,.461-2.7c.527-1.144.178-1.632.178-1.632l-.334-3.266Z",
    transform: "translate(-120.896 -354.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M245.721,373.242s-3.354,1.267-4.421.154-.955-6.305-.955-6.305-1.021-9.6-1.667-11.174-.308-12.953-.308-12.953a7.1,7.1,0,0,0-.81-1.858.38.38,0,0,0-.08-.066l.131.028.461.1.706.566,2.267,14.631s3.931,11.266,4.66,15.814Z",
    transform: "translate(-214.534 -293.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M293.074,547.693h-.038c-.421.054-4.152.5-4.166-.271a2.39,2.39,0,0,1,.015-.269l3.456-.354.684.7h0c.012.046.023.086.032.117Z",
    transform: "translate(-258.021 -467.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M289.5,379.63l2.453,1.278a55.4,55.4,0,0,1,2.368,7.551s1.51,6.07.461,8.566-.955,7.452-.955,7.452-.6.91-.844.666.089.955.089.955-4.188.557-4.208-.268a42.261,42.261,0,0,1,.961-4.755s.266-9.353-.112-10.819S289.5,379.63,289.5,379.63Z",
    transform: "translate(-258.019 -326.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M234.434,444.41s-1.384,3.376-1.822,3.6.089,1.11.089,1.11S235.213,445.61,234.434,444.41Z",
    transform: "translate(-210.267 -380.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M228.247,367.39c.015-.065-1.646,1.629-2.088,1.881S227.773,369.257,228.247,367.39Z",
    transform: "translate(-204.901 -315.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M197.725,442.67s-2.533,1.639-2.2,2.285S197.725,442.67,197.725,442.67Z",
    transform: "translate(-179.005 -379.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M239.93,598.12a13.635,13.635,0,0,0,5.51,1.733Z",
    transform: "translate(-216.607 -510.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M206.27,619.79s2,2.51,2.911,2.577S206.27,619.79,206.27,619.79Z",
    transform: "translate(-188.123 -529.242)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M211.193,683.79c-.089.045-1.133,2.265-2.2,2.333S211.193,683.79,211.193,683.79Z",
    transform: "translate(-190.247 -583.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M284.72,715.061s1.981-.443,2.421.978C287.141,716.039,287.008,715.594,284.72,715.061Z",
    transform: "translate(-254.509 -609.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M276.05,767.349s2.4-.489,2.91.178S276.05,767.349,276.05,767.349Z",
    transform: "translate(-247.172 -653.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M218.961,775.67c0,.022-2.444.489-2.347.8s2.605.266,2.694-.223a.461.461,0,0,0-.348-.577Z",
    transform: "translate(-196.875 -661.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M270.85,788.615s4.014-.489,3.762.355S270.85,788.615,270.85,788.615Z",
    transform: "translate(-242.772 -671.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M134.18,467.81c.023.066,2.644.421,3,1.266a22.808,22.808,0,0,0-2.976-1.2",
    transform: "translate(-127.12 -400.634)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M146.981,512.45s-2.178.689-2.024,1.733S144.737,513.7,146.981,512.45Z",
    transform: "translate(-136.233 -438.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M151.56,541.8s.794-1.089,1.549-.889S151.56,541.8,151.56,541.8Z",
    transform: "translate(-141.827 -462.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M186.567,273.938a1.27,1.27,0,0,1-.255.191,2.918,2.918,0,0,0-1.1,1.579,3.319,3.319,0,0,1-1.144,1.562c-.723.435-1.676.275-2.428.657a1.893,1.893,0,0,0-1.006,1.858,5.464,5.464,0,0,0,.215.85,6.138,6.138,0,0,1,.229,1.845.238.238,0,0,1,0,.057,5.133,5.133,0,1,1,5.5-8.6Z",
    transform: "translate(-164.398 -235.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M172.372,256.007a4.762,4.762,0,0,0-3.051-2.307,5.118,5.118,0,0,0-2.962-.063,10.072,10.072,0,0,0-1.55.726,8.764,8.764,0,0,0-2.714,1.652.811.811,0,0,0-.271.663,1.8,1.8,0,0,0,.269.481,1.47,1.47,0,0,1,.014,1.206,12.089,12.089,0,0,0-.443,1.161,1.217,1.217,0,0,0,.238,1.163,5.393,5.393,0,0,0,.449.32,2.42,2.42,0,0,1,.426.484l.847,1.158a11.685,11.685,0,0,1,1.061,1.633,8.058,8.058,0,0,0,.657,1.244,1.417,1.417,0,0,0,1.19.635.226.226,0,0,0,.188-.089.235.235,0,0,0,.025-.118,6.053,6.053,0,0,0-.229-1.845,5.466,5.466,0,0,1-.215-.85,1.9,1.9,0,0,1,1.006-1.858c.754-.38,1.707-.22,2.43-.655a3.362,3.362,0,0,0,1.144-1.564c.308-.651.472-1.213,1.1-1.579A1.1,1.1,0,0,0,172.372,256.007Z",
    transform: "translate(-150.336 -219.235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M216.61,815.58s.781,1,.581,1.566S216.61,815.58,216.61,815.58Z",
    transform: "translate(-196.873 -694.922)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M285.68,824.286s.174-1.341.873-1.353a2.35,2.35,0,0,1,1.267.132c.534.2,1.033.524.875.574s-.923-.769-1.692-.352A5.6,5.6,0,0,0,285.68,824.286Z",
    transform: "translate(-255.321 -701.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M190.075,351.639l2.19-1.538s-3.216-1.9-3.6-1.633-.646,2.667-.646,2.667Z",
    transform: "translate(-172.68 -299.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M190.065,350.787l2.2-1.575s-3.216-1.9-3.6-1.633-.646,2.8-.646,2.8Z",
    transform: "translate(-172.68 -298.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M190.065,350.787l2.2-1.575s-3.216-1.9-3.6-1.633-.646,2.8-.646,2.8Z",
    transform: "translate(-172.68 -298.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M147.667,347.313l-.066-.034a.568.568,0,0,0-.615.065l-6.594,5.35a8.838,8.838,0,0,0-1.23,5.4l3.888,5.51s.444-1.867.978-1.512c0,0,.755,9.553,0,10.931s-1.089,6.531-1.089,6.531l2.554.289a20.24,20.24,0,0,1,.866-4.732c.6-1.244.923-5.519.923-5.519s.54-6.211.451-8.879-.866-8.4-.866-8.4A25.392,25.392,0,0,1,147.667,347.313Z",
    transform: "translate(-131.319 -298.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M222.219,344.423l-2.739-1.015s3.489-3.82,3.923-1.7Z",
    transform: "translate(-199.302 -293.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M222.219,343.534l-2.739-1.013s3.489-3.822,3.923-1.7Z",
    transform: "translate(-199.302 -292.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M222.219,343.534l-2.739-1.013s3.489-3.822,3.923-1.7Z",
    transform: "translate(-199.302 -292.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M236.72,340.876a.154.154,0,0,1,.112.023Z",
    transform: "translate(-213.891 -293.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M238.45,339.135l7.271,1.569s2,.444,3.443,5.464-1.978,11.172-1.978,11.172l-.755-.641.378,14.663s-3.356,1.266-4.421.154-.957-6.305-.957-6.305-1.021-9.6-1.667-11.182-.308-12.953-.308-12.953S238.856,339.047,238.45,339.135Z",
    transform: "translate(-215.355 -291.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M281.153,399.537a41.513,41.513,0,0,0,.223,7.909,43.084,43.084,0,0,0,1.259,6.087L281.976,400S281.464,399.244,281.153,399.537Z",
    transform: "translate(-251.41 -342.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M275.9,375.06c.178.111.957,1.955.6,2.711S275.9,375.06,275.9,375.06Z",
    transform: "translate(-247.046 -322.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M193.936,260.893a4,4,0,0,0-1.6-1.673,3.794,3.794,0,0,1,1.2,1.407,1.126,1.126,0,0,1-.389,1.6,2.975,2.975,0,0,0-1.1,1.579,3.322,3.322,0,0,1-1.146,1.562c-.723.437-1.675.277-2.428.655a1.9,1.9,0,0,0-1.006,1.859,5.3,5.3,0,0,0,.215.85,6.04,6.04,0,0,1,.228,1.845.237.237,0,0,1-.023.118.226.226,0,0,1-.188.089,1.076,1.076,0,0,1-.547-.1,1.275,1.275,0,0,0,.947.368.226.226,0,0,0,.188-.089.252.252,0,0,0,.025-.118A6.1,6.1,0,0,0,188.08,269a5.3,5.3,0,0,1-.215-.85,1.9,1.9,0,0,1,1.006-1.858c.754-.38,1.705-.22,2.428-.655a3.364,3.364,0,0,0,1.146-1.564c.308-.651.471-1.213,1.1-1.579A1.109,1.109,0,0,0,193.936,260.893Z",
    transform: "translate(-171.944 -224.122)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 6.305,
    cy: 0.866,
    rx: 6.305,
    ry: 0.866,
    transform: "translate(142.593 116.29)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 4.481,
    cy: 0.615,
    rx: 4.481,
    ry: 0.615,
    transform: "translate(94.989 124.665)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 4.481,
    cy: 0.615,
    rx: 4.481,
    ry: 0.615,
    transform: "translate(54.892 120.106)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M458.933,791.21a1.79,1.79,0,0,0,.589-.89.79.79,0,0,0-.412-.906c-.378-.145-.783.118-1.089.383a1.453,1.453,0,0,1-1.058.51,1.614,1.614,0,0,0,.5-1.508.648.648,0,0,0-.138-.308c-.211-.224-.592-.128-.843.049a3.136,3.136,0,0,0-1.027,2.625,5.036,5.036,0,0,1-.015-1.076,1.108,1.108,0,0,0-.406-.957,1.23,1.23,0,0,0-.615-.154,1.277,1.277,0,0,0-1,.286.991.991,0,0,0,.038,1.23,3.918,3.918,0,0,0,1.041.834,2.306,2.306,0,0,1,.743.709.636.636,0,0,1,.055.128h2.255a6.343,6.343,0,0,0,1.389-.955Z",
    transform: "translate(-397.092 -671.888)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1041.689,770.109a1.8,1.8,0,0,0,.6-.891.794.794,0,0,0-.412-.906c-.378-.145-.783.118-1.089.383a1.453,1.453,0,0,1-1.059.51,1.607,1.607,0,0,0,.5-1.509.615.615,0,0,0-.138-.308c-.209-.224-.59-.128-.841.049a3.136,3.136,0,0,0-1.027,2.625,4.948,4.948,0,0,1-.015-1.076,1.111,1.111,0,0,0-.406-.957,1.232,1.232,0,0,0-.615-.154,1.281,1.281,0,0,0-1.006.286.989.989,0,0,0,.04,1.23,3.94,3.94,0,0,0,1.041.834,2.306,2.306,0,0,1,.743.709.725.725,0,0,1,.055.128h2.253A6.32,6.32,0,0,0,1041.689,770.109Z",
    transform: "translate(-890.234 -654.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M711.534,816.859a1.8,1.8,0,0,0,.591-.89.8.8,0,0,0-.412-.906,1.155,1.155,0,0,0-1.089.383,1.454,1.454,0,0,1-1.06.51,1.61,1.61,0,0,0,.5-1.509.633.633,0,0,0-.138-.307c-.211-.225-.591-.128-.843.049a3.139,3.139,0,0,0-1.027,2.627,4.937,4.937,0,0,1-.014-1.076,1.108,1.108,0,0,0-.406-.957,1.243,1.243,0,0,0-.615-.154,1.286,1.286,0,0,0-1.006.286.989.989,0,0,0,.04,1.23,4.023,4.023,0,0,0,1.039.833,2.307,2.307,0,0,1,.751.72.778.778,0,0,1,.055.126h2.251A6.258,6.258,0,0,0,711.534,816.859Z",
    transform: "translate(-610.847 -693.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M879.836,285.034a6.018,6.018,0,0,1-4.807-3.2,3.229,3.229,0,0,1-.486-1.372,1.617,1.617,0,0,1,.055-.329,3.231,3.231,0,0,0,.154-.5.843.843,0,0,0,0-.206v-.009a1.206,1.206,0,0,0-.443-.987c-.274-.257-.607-.443-.889-.69a4.163,4.163,0,0,1-1.147-3.145v-.062c.009-.5.049-1,.045-1.495a6.247,6.247,0,0,0-.037-.847,2.789,2.789,0,0,0-.9-1.87c-1.444-1.17-3.872.048-5.365-1.06-.364-.269-.658-.671-1.1-.769a1.864,1.864,0,0,0-1,.135c-1.1.363-2.328.841-2.759,1.911-.246.615-.177,1.306-.4,1.924a11.054,11.054,0,0,1-.629,1.163,1.82,1.82,0,0,0-.235.97,1.118,1.118,0,0,0,.072.517,1.3,1.3,0,0,0,.357.509,1.687,1.687,0,0,1-.215.341c-.281.344-.714.591-1.006.923a2.19,2.19,0,0,0-.254,2.219c.268.738.747,1.41,1.077,2.128a1.151,1.151,0,0,1,.109.972,2.73,2.73,0,0,1-.486.564,1.778,1.778,0,0,0-.44.987c-3.3.752-3.3,3.4-3.3,3.4h0l-1.778,4.481s-.285.754-.615,1.749L851.3,293l1.455,2.451a7.684,7.684,0,0,0-.409,2.388s-.654,3.076.509,3.612l2.568,1.155a1.416,1.416,0,0,0,.355.154l.1.046a.272.272,0,0,0,.24,0h.042a.326.326,0,0,0,.154-.022.277.277,0,0,0,.128-.14.058.058,0,0,0,0-.014l.769-.223.652.769c.294.206.581.386.863.547l-1,10.027s-.163,13.327-.653,16.361a8.435,8.435,0,0,0-.115,2.411l-.018.034c.121.857.437,1.026.437,1.026v-.012l.018.012a8.7,8.7,0,0,1,.528-1.13v.218c-.009,1.132-.045,2.714-.154,3.743a58.419,58.419,0,0,0,.509,7.548l.245,5.275a4.878,4.878,0,0,1-.6,2.568A12.138,12.138,0,0,0,856.538,355a.88.88,0,0,0,0,.108h0l-1.286,1.5s-.492.758.615,1.064a5.908,5.908,0,0,0,2.448-.2,1.636,1.636,0,0,0,1.27-1.592,5.629,5.629,0,0,1,1.049-1.988l.208,1.213,1.384.343.177-3.326a1.456,1.456,0,0,0,.1-.587h0c.272-2.365-.641-2.153-.641-2.153a.154.154,0,0,1,.045.083c-.015-.026-.031-.054-.045-.082h0a5.918,5.918,0,0,1-.286-2.922s.727-5.272.983-6.663a48.406,48.406,0,0,0,.046-6.007,1.93,1.93,0,0,0-.008-.217c2.142-.028,4.767-.1,6.613-.28v.218l-.341,12.457a6.849,6.849,0,0,1-.475,2.316c0,.014-.012.028-.017.042a10.1,10.1,0,0,0-.689,3.259l-.154,3.958v.109h0c-.275.106-.709.412-.721,1.3-.018,1.3,2.271.866,2.271.866a2.326,2.326,0,0,0,2.307-2.384s.074-2.185.182-3.648-.345-1.14-.345-1.14l-.034,4.152v-3.614l.035-.529v-.015h0l.008-.112.285-4.291s2.108-7.151,2.436-8.523a32.169,32.169,0,0,0,.058-5.536,1.625,1.625,0,0,0-.009-.215c.652-.058,1.23-.065,1.462-.065h.106s-.109-11.485-.381-15.818-.709-8.289-1.8-9.481a19.814,19.814,0,0,1-2.2-4.59,23.093,23.093,0,0,0,4.037,1.323c3.454.723,2.982-2.276,2.982-2.276l-.351-5.67h.023a28.814,28.814,0,0,0-.381-4.434,13.157,13.157,0,0,0-.889-3.229c.375-.143.744-.308,1.107-.461.938-.414,2-1,2.131-2.013H879.8A1.412,1.412,0,0,0,879.836,285.034Zm-21.41,8.2h0c.009.586-.014,1.6-.048,2.725l-1.1-1.464,1.1-1.784ZM873.122,296.207Zm.461,2.214-1.827-.587a8.243,8.243,0,0,1,1.129-1.4l.154-.154-.057.012.089-.08.052-.012-.085.08.1-.02a3.123,3.123,0,0,0,.623,1.252c.652.726-.185.906-.185.906Z",
    transform: "translate(-733.958 -231.94)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M825.455,774.95,825.24,779l-1.363-.34-.288-1.685Z",
    transform: "translate(-696.935 -655.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M825.455,774.95,825.24,779l-1.363-.34-.288-1.685Z",
    transform: "translate(-696.935 -655.761)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M956.51,693.638l2.079.431,1.538-1.363v-3.837l.034-.524v-.015h0l.008-.111.28-4.26s2.079-7.1,2.4-8.458a32.164,32.164,0,0,0,.058-5.5c-.031-.661-.058-1.1-.058-1.1l-4.589-1.112-.1,3.537-.335,12.364a6.822,6.822,0,0,1-.471,2.3l-.015.042a10.036,10.036,0,0,0-.666,3.24l-.154,3.929v.109Z",
    transform: "translate(-822.989 -569.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M980.29,800.632v.109h0l.008-.111Z",
    transform: "translate(-843.112 -682.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M956.51,828.948l2.079.431,1.538-1.362v-.326a.437.437,0,0,1-.221.352l-.022.012a4.136,4.136,0,0,1-2.334.461l-.812-.069a.854.854,0,0,0-.214.052v.109Z",
    transform: "translate(-822.989 -705.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M956.038,805.7l.021-.012a.436.436,0,0,0,.223-.382l.034-4.131s.449-.318.341,1.133-.18,3.622-.18,3.622A2.306,2.306,0,0,1,954.2,808.3s-2.259.429-2.242-.861.934-1.344.934-1.344l.81.071A4.153,4.153,0,0,0,956.038,805.7Z",
    transform: "translate(-819.138 -682.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M886.087,700.173c.054.932,2.8.394,2.8.394l1.845-3.585s1.538-1.184.769-2.224a1.575,1.575,0,0,1-.114-.177v-.009h0c-.017-.028-.031-.055-.046-.085h0a5.9,5.9,0,0,1-.282-2.9s.717-5.229.969-6.613a48.34,48.34,0,0,0,.044-5.964c-.023-.743-.044-1.244-.044-1.244l-4.555-1.218v1.358c-.009,1.123-.043,2.694-.154,3.715a58.388,58.388,0,0,0,.5,7.494l.241,5.238a4.86,4.86,0,0,1-.6,2.542,12.238,12.238,0,0,0-1.369,3.169A.6.6,0,0,0,886.087,700.173Z",
    transform: "translate(-763.394 -577.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M886.1,799.392c.054.932,2.8.394,2.8.394l1.845-3.585s1.538-1.184.769-2.224a1.569,1.569,0,0,1-.114-.177,8.885,8.885,0,0,1-.615,1.9s-1.524,3.05-2,3.748-2.591-.129-2.67-.154A.619.619,0,0,0,886.1,799.392Z",
    transform: "translate(-763.406 -676.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M883.835,793.144s.9-.209.634,2.139h0a1.515,1.515,0,0,1-.715,1.342,5.13,5.13,0,0,0-2.144,2.974h0a1.624,1.624,0,0,1-1.252,1.583,5.879,5.879,0,0,1-2.416.192c-1.093-.308-.615-1.057-.615-1.057l1.255-1.489s2.187.861,2.671.162,2-3.748,2-3.748S884.109,793.341,883.835,793.144Z",
    transform: "translate(-755.894 -675.932)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M967.407,670.56l-.1,3.537a4.553,4.553,0,0,0,2.248-.517c.321-.5,1.5-.712,2.5-.8-.031-.661-.058-1.1-.058-1.1Z",
    transform: "translate(-832.128 -572.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M895.06,680.668a1.7,1.7,0,0,1,.5-.606c.484-.269.432,1.721.432,1.721s1.607.015,3.666-.011c-.023-.744-.045-1.244-.045-1.244l-4.555-1.218S895.068,679.877,895.06,680.668Z",
    transform: "translate(-770.989 -579.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M889.044,508.3s.538-1.456,1.021-1.724.432,1.721.432,1.721,11.832.108,12.424-.807,4.034-.86,4.034-.86-.108-11.4-.377-15.706-.7-8.229-1.775-9.412a21.165,21.165,0,0,1-2.3-4.895c-.334-.9-.554-1.559-.554-1.559l-11.294.646-.092.913-1.2,12s-.154,13.225-.646,16.243S889.044,508.3,889.044,508.3Z",
    transform: "translate(-765.491 -406.769)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(123.099 68.299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M916.283,507.541c.59-.913,4.034-.86,4.034-.86s-.108-11.4-.377-15.706-.7-8.229-1.775-9.412a21.165,21.165,0,0,1-2.3-4.895c-.28-.758-.48-1.343-.537-1.51l.876-.049s.22.657.554,1.559a21.5,21.5,0,0,0,2.3,4.895c1.077,1.183,1.506,5.109,1.775,9.412s.371,15.7.371,15.7-3.442-.055-4.032.867c-.506.781-9.213.817-11.741.81C908.672,508.337,915.821,508.24,916.283,507.541Z",
    transform: "translate(-902.863 -475.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.3,679.862c.218-.122.328.215.381.615a8.705,8.705,0,0,0-.509,1.1s-.308-.168-.431-1.018A1.939,1.939,0,0,1,889.3,679.862Z",
    transform: "translate(-888.74 -648.353)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M901.989,286.741c-.781,1.067.009,2.582-.829,3.619-.277.343-.7.587-.992.923a2.187,2.187,0,0,0-.251,2.2c.263.734.738,1.4,1.064,2.113a1.151,1.151,0,0,1,.109.964,2.539,2.539,0,0,1-.48.561,2.023,2.023,0,0,0-.264,2.145,7,7,0,0,0,1.384,1.918.946.946,0,0,0,1.378.315,5.6,5.6,0,0,0,2.7-3.176,5.664,5.664,0,0,0-.231-3.9c-.461-1.087-1.212-2.13-1.218-3.28,0-.912.469-1.782.552-2.691a3.44,3.44,0,0,0-1.884-3.337C903.118,285.832,902.393,286.2,901.989,286.741Z",
    transform: "translate(-774.947 -246.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M901.989,286.741c-.781,1.067.009,2.582-.829,3.619-.277.343-.7.587-.992.923a2.187,2.187,0,0,0-.251,2.2c.263.734.738,1.4,1.064,2.113a1.151,1.151,0,0,1,.109.964,2.539,2.539,0,0,1-.48.561,2.023,2.023,0,0,0-.264,2.145,7,7,0,0,0,1.384,1.918.946.946,0,0,0,1.378.315,5.6,5.6,0,0,0,2.7-3.176,5.664,5.664,0,0,0-.231-3.9c-.461-1.087-1.212-2.13-1.218-3.28,0-.912.469-1.782.552-2.691a3.44,3.44,0,0,0-1.884-3.337C903.118,285.832,902.393,286.2,901.989,286.741Z",
    transform: "translate(-774.947 -246.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M923.56,547.78a10.414,10.414,0,0,0-4.409,1.516,29.622,29.622,0,0,1-4.171,2.165",
    transform: "translate(-787.845 -468.306)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M924,571.76a6.472,6.472,0,0,0-4.066,1.976c-.38.4-.707.855-1.1,1.241a4.919,4.919,0,0,1-2.179,1.23",
    transform: "translate(-789.259 -488.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M917.779,590a7.106,7.106,0,0,0-3.268,1.97c-.24.258-.461.537-.7.794a12.992,12.992,0,0,1-4.893,2.828",
    transform: "translate(-782.717 -504.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M931.481,336.5a32.232,32.232,0,0,0,.323,3.737,4.817,4.817,0,0,0,.646,2.018c.86,1.023-4.2,2.394-4.2,2.394l-2.985-2.307s2.367-2.179,1.264-4.306S931.481,336.5,931.481,336.5Z",
    transform: "translate(-796.553 -289.45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M901.59,476.619h11.94c-.334-.9-.554-1.559-.554-1.559l-11.294.646Z",
    transform: "translate(-776.514 -406.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M883.77,383.007h12.764a4.421,4.421,0,0,1,.512-3.383,7.47,7.47,0,0,1,1.336-1.735l.088-.078,4.46-.989.24-.052s.035-8.1-2.833-9.215a16.82,16.82,0,0,1-4.59-2.614l-3.943,1.218-2.9-1.469c-.932,1-3.406.615-3.406.615-4.052.461-4.052,3.514-4.052,3.514s2.367,5.522,2.547,5.522S883.77,383.007,883.77,383.007Z",
    transform: "translate(-759.463 -313.372)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M906.049,441.576s-2.6-.577-3.489-1.586",
    transform: "translate(-777.335 -377.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M994.014,430.64,991,433.114a4.984,4.984,0,0,0,.1.581l.088-.078,4.46-.989Z",
    transform: "translate(-852.175 -369.18)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M957.44,458.865s.661.372,1.673.86h1.735a4.422,4.422,0,0,1,.512-3.383l-3.065-.992C959.341,456.319,957.44,458.865,957.44,458.865Z",
    transform: "translate(-823.776 -390.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M863.479,385.18l-1.793.967-1.758,4.446s-1.828,4.876-1.65,6.168c0,0-.644,3.046.5,3.585l2.993,1.353a.277.277,0,0,0,.358-.383c-.426-.807-.894-2.068-.154-2.768l-.861-1.792,3.117-5.087,1.038-1.75Z",
    transform: "translate(-739.71 -330.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M918.9,436.957a2.769,2.769,0,0,0,2.414,1.975l1.91,1.559,2.025.923.824.374.351-2.528-.8-.435-.923-.506s-2.09-3.789-5.4-2.188A.734.734,0,0,0,918.9,436.957Z",
    transform: "translate(-791.147 -373.491)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M919.611,435.568a2.769,2.769,0,0,0,2.414,1.975l1.91,1.561,2.025.923.824.374.351-2.528-.8-.434-.923-.507s-2.09-3.788-5.4-2.188A.734.734,0,0,0,919.611,435.568Z",
    transform: "translate(-791.749 -372.318)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 4.626,
    cy: 4.626,
    r: 4.626,
    transform: "translate(126.967 41.076)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "u",
    cx: 4.626,
    cy: 4.626,
    r: 4.626,
    transform: "translate(126.967 40.968)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M954.984,365.731l-1.384-2.7s2.036-.821,2.184-1.775,1.95,1.117,1.559,1.8A25.75,25.75,0,0,1,954.984,365.731Z",
    transform: "translate(-820.526 -310.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M954.984,364.331l-1.384-2.7s2.036-.821,2.184-1.775,1.95,1.118,1.559,1.8A25.922,25.922,0,0,1,954.984,364.331Z",
    transform: "translate(-820.526 -309.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M858.05,430.238l7.689,10.333s-2.833,1.538-6.742-1.22l-1.692-2.007-4.806-8.1Z",
    transform: "translate(-734.974 -367.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M877.718,457.6l.7-.018s4.275-4.152,5.324-2.052-2.662,4.06-2.662,4.06l-1.129.615-1.479.431-.941-1.264Z",
    transform: "translate(-756.155 -389.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M873.425,472.116a1.045,1.045,0,0,1,.018.723.274.274,0,0,1-.128.138.308.308,0,0,1-.154.022,1.469,1.469,0,0,1-.964-.478,4.348,4.348,0,0,1-.626-.9,1.651,1.651,0,0,1-.32-1.076,1.552,1.552,0,0,1,.793-.923c.709-.469.726.077.887.68Z",
    transform: "translate(-750.83 -402.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M872.725,472.116a1.046,1.046,0,0,1,.018.723.274.274,0,0,1-.128.138.309.309,0,0,1-.154.022,1.469,1.469,0,0,1-.964-.478,4.351,4.351,0,0,1-.626-.9,1.651,1.651,0,0,1-.32-1.076,1.552,1.552,0,0,1,.794-.923c.709-.469.726.077.887.68Z",
    transform: "translate(-750.238 -402.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M809.72,392.974l.358-.6-.314,1.123Z",
    transform: "translate(-685.198 -332.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M961,456.988l.824.374.351-2.528-.8-.434C961.923,455.024,961.448,456.184,961,456.988Z",
    transform: "translate(-826.788 -389.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M961.651,449.044s-2.662.161-3.791-.564",
    transform: "translate(-824.131 -384.276)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(125.857 51.533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M973.852,382.376a7.511,7.511,0,0,1,1.338-1.735,3.7,3.7,0,0,1,.394-.215l4.152-.852.24-.052s.037-8.1-2.833-9.215a17.323,17.323,0,0,1-4.474-2.521l.315-.1a16.7,16.7,0,0,0,4.589,2.614c2.868,1.109,2.836,9.218,2.836,9.218h-.431l-4.251.814-.24.229a8.2,8.2,0,0,0-1.358,1.795,4.5,4.5,0,0,0-.355,3.4h-.44A4.475,4.475,0,0,1,973.852,382.376Z",
    transform: "translate(-962.52 -367.444)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.67,370.048c.069-.009.135-.02.206-.028a7.575,7.575,0,0,0,.878.072A7.907,7.907,0,0,1,906.67,370.048Z",
    transform: "translate(-906.67 -369.416)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.8,367.554l-2.627-1.324a1.468,1.468,0,0,0,.154-.14l2.74,1.384Z",
    transform: "translate(-925.71 -366.09)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M966.315,429.24l1.758,2.153.358,5.844s.461,2.976-2.94,2.259a31.4,31.4,0,0,1-7.351-2.94s1.9-2.547.861-3.514l4.876,1.578s.824-.18.178-.9a4.032,4.032,0,0,1-.76-2.008Z",
    transform: "translate(-824.368 -367.995)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M1016.43,469.35l.969,1.11A1.4,1.4,0,0,1,1016.43,469.35Z",
    transform: "translate(-873.694 -401.937)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M917.44,437.1l1.506,1.936-.752.18Z",
    transform: "translate(-776.352 -369.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M907.636,278.529a1.565,1.565,0,0,1,.154-1.261,10.281,10.281,0,0,0,.615-1.155c.223-.615.154-1.3.4-1.91.426-1.061,1.636-1.538,2.722-1.9a1.844,1.844,0,0,1,.99-.135c.434.1.724.5,1.076.769,1.473,1.1,3.868-.111,5.292,1.052a2.774,2.774,0,0,1,.892,1.856,16.7,16.7,0,0,1-.008,2.112,4.342,4.342,0,0,0,1.13,3.4c.278.246.606.432.877.686a1.2,1.2,0,0,1,.437.98,3.34,3.34,0,0,1-.154.5,2.536,2.536,0,0,0,.423,1.9,5.936,5.936,0,0,0,4.743,3.182c-.134,1-1.176,1.587-2.1,2a8.29,8.29,0,0,1-3.708.973,2.981,2.981,0,0,1-2.862-2.153c-.078-.435-.068-.969-.446-1.2-.228-.138-.523-.1-.769-.208a1.371,1.371,0,0,1-.649-.913,8.241,8.241,0,0,1-.383-2.344,4.882,4.882,0,0,0-.424-2.748c-.5-.718-1.375-1.077-1.945-1.744a3.443,3.443,0,0,0-1.962-1.467C910.812,278.635,908.342,280.258,907.636,278.529Z",
    transform: "translate(-781.565 -235.059)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M907.636,277.129a1.565,1.565,0,0,1,.154-1.261,10.284,10.284,0,0,0,.615-1.155c.223-.615.154-1.3.4-1.91.426-1.061,1.636-1.538,2.722-1.9a1.843,1.843,0,0,1,.99-.135c.434.1.724.5,1.076.769,1.473,1.1,3.868-.111,5.292,1.052a2.778,2.778,0,0,1,.892,1.856,16.7,16.7,0,0,1-.008,2.111,4.342,4.342,0,0,0,1.13,3.4c.278.246.606.432.877.686a1.2,1.2,0,0,1,.437.98,3.422,3.422,0,0,1-.154.5,2.532,2.532,0,0,0,.423,1.9,5.936,5.936,0,0,0,4.743,3.182c-.134,1-1.176,1.587-2.1,2a8.271,8.271,0,0,1-3.708.973,2.978,2.978,0,0,1-2.862-2.161c-.078-.435-.068-.969-.446-1.2-.228-.138-.523-.1-.769-.208a1.371,1.371,0,0,1-.649-.913,8.24,8.24,0,0,1-.383-2.344,4.882,4.882,0,0,0-.424-2.748c-.5-.718-1.375-1.076-1.945-1.744a3.444,3.444,0,0,0-1.962-1.467C910.812,277.243,908.342,278.858,907.636,277.129Z",
    transform: "translate(-781.565 -233.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M924.363,366.121l2.651-2.153s-1.815-.984-2.032-1.824-1.669.4-1.521,1.152S924.363,366.121,924.363,366.121Z",
    transform: "translate(-795.014 -310.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M925.063,364.021l2.651-2.153s-1.815-.984-2.032-1.824-1.668.4-1.521,1.152S925.063,364.021,925.063,364.021Z",
    transform: "translate(-795.606 -309.202)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 0.211,
    cy: 0.211,
    r: 0.211,
    transform: "translate(132 54.257)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 0.211,
    cy: 0.211,
    r: 0.211,
    transform: "translate(132 55.429)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 0.211,
    cy: 0.211,
    r: 0.211,
    transform: "translate(132 56.599)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(126.023 38.465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M913.485,282.912c.209-.577.165-1.223.36-1.8a2.091,2.091,0,0,0-.223.412c-.243.606-.175,1.3-.4,1.912,0,.011-.011.023-.015.035A3.4,3.4,0,0,0,913.485,282.912Z",
    transform: "translate(-912.371 -281.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.6,315.089a8.271,8.271,0,0,1-3.709.973,2.975,2.975,0,0,1-2.86-2.161c-.079-.435-.068-.969-.446-1.2-.228-.138-.523-.1-.769-.208a1.367,1.367,0,0,1-.649-.914,8.239,8.239,0,0,1-.383-2.347,4.894,4.894,0,0,0-.424-2.748c-.5-.718-1.375-1.076-1.945-1.744a3.447,3.447,0,0,0-1.964-1.467c-1.184-.154-3.655,1.461-4.36-.268a1.358,1.358,0,0,1,.045-1c-.051.086-.1.172-.145.26a1.518,1.518,0,0,0-.154,1.261c.706,1.729,3.176.106,4.361.268a3.472,3.472,0,0,1,1.964,1.467c.571.661,1.449,1.026,1.944,1.745a4.867,4.867,0,0,1,.426,2.747,8.207,8.207,0,0,0,.381,2.345,1.353,1.353,0,0,0,.649.913c.246.1.541.069.769.208.377.228.368.769.444,1.2a2.98,2.98,0,0,0,2.862,2.162,8.268,8.268,0,0,0,3.708-.975c.849-.377,1.794-.9,2.048-1.759A4.418,4.418,0,0,1,925.6,315.089Z",
    transform: "translate(-907.753 -298.796)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawAnalysis);
export default __webpack_public_path__ + "static/media/undraw_analysis_.cf15a03f19a18d4e42182b7d27a0e891.svg";
export { ForwardRef as ReactComponent };